import React, { useState } from 'react';
import './comment-card.style.css';
import UserContext from '../../utils/userContext'
import axios from 'axios'
import { Button, TextArea, Form } from 'semantic-ui-react'
import 'emoji-mart/css/emoji-mart.css'
import { Picker } from 'emoji-mart'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

library.add(fas);

const CommentEditSegment = (props) => {
    var commentHeaderText = { "create": "แสดงความคิดเห็น", "edit": "แก้ไขความคิดเห็น", "reply": "ตอบกลับความคิดเห็น" }
    return (
        <div className="comment-editor-wrap">
            <div className="comment-header">{commentHeaderText[props.actionToEditor]}</div>
            <CommentEditor contentId={props.contentId} replyToCommentId={props.replyToCommentId} fullComment={props.fullComment} onHideEditor={props.onHideEditor} onUpdateComments={props.onUpdateComments} action={props.actionToEditor} prevComment={props.prevComment}/>
        </div>
    )
}

class CommentEditor extends React.Component {
    static contextType = UserContext
    constructor(props) {
        super(props);
        this.state = {
            commentText: "",
            showEMJ: false

        };
    };

    handleCommentChange(event) {
        this.setState({ commentText: event.target.value })
    }


    onReplyClick() {
        // console.log(this.context.userData.id);
        if(this.state.commentText === ""){
            return false;
        }
        let formData = {
            "userId": this.context.userData.id,
            "commentData": {
                "commentText": this.state.commentText,
                "replyTo": this.props.replyToCommentId
            }
        }
        let method = "post"
        let commentId = ""

        if (this.props.action === "edit") {
            method = "put"
            commentId = this.props.replyToCommentId
        }
        var self = this
        return axios({
            method: method,
            url: `https://www.borntodev.com/wp-json/devblog/v1/posts/${this.props.contentId}/comments/${commentId}?full=${this.props.fullComment}`,
            data: formData,
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then(function (response) {
                // console.log(response.data.commentData);
                self.setState({ commentText: "" })
                self.props.onUpdateComments(response.data.commentData)
                self.props.onHideEditor()
                // return response.data;
            })
            .catch(function (response) {
                // console.log(response);
                return response.data;
            });
    }

    onEmojiClick = (event, emojiObject) => {
        this.setState({ commentText: this.state.commentText + event.native })
        this.onShowemoji()
    }

    onShowemoji = () => {
        let showEMJ = !this.state.showEMJ
        this.setState({ showEMJ: showEMJ })
    }

    componentDidMount() {
        this.setState({commentText: this.props.prevComment})
    }

    componentDidUpdate(prevProps) {
        if(prevProps.actionToEditor !== this.props.actionToEditor){
            this.setState({commentText: this.props.prevComment})
        }
    }


    render() {
        // console.log("hello")
        return (
            <div className=" comment-editor-segment">
                <Form>
                    <TextArea className="comment-editor " onChange={this.handleCommentChange.bind(this)} value={this.state.commentText} />
                </Form>
                <br />
                <div style={{ display: this.state.showEMJ === true ? "block" : "none" }} className="emoji-picker-overlay">
                    <div className="emoji-picker">
                        <Picker native={true} onSelect={this.onEmojiClick.bind(this)} />
                    </div>

                    <div className="emoji-bg"  onClick={this.onShowemoji.bind(this)} ></div>
                </div>
                <div className="comment-button-secion">
                    <div className="comment-emoji-show">
                        <FontAwesomeIcon icon={['fas', 'smile']} onClick={this.onShowemoji.bind(this)} />
                    </div>
                    <div className="comment-reply" onClick={this.onReplyClick.bind(this)}>
                        ส่งความคิดเห็น
                    </div>
                </div>
            </div>
        )
    }
}

export { CommentEditSegment };
